import React, { memo } from "react";
import { generateUrl } from "@/utils/cloudinary";
import { SITE_URL } from "@/misc/constants";
import View from "./view";
import PT from "prop-types";
import { LinkGenerator } from "@/utils/LinkGenerator";
import { useInView } from "react-intersection-observer";
import { useMut } from "@/hooks/useMut";

const Slide = ({
  slide,
  isOwner,
  remove,
  isFavorite,
  toggleLike,
  isAuth,
  openShareModal,
  index,
  openGallery,
  defaultAltText,
  t,
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
  });
  const url = generateUrl(slide.photo, {
    width: 340,
    height: 430,
    crop: "fill",
  });
  const removeMut = useMut(() => remove(slide), {
    t,
    notifyOnError: true,
    confirm: true,
  });
  const onSlideClick = ({ target }) => {
    if (target.closest(".slider-remove-btn")) return;
    if (target.closest(".slider-meta")) return;
    openGallery(index);
  };
  const onShare = () =>
    openShareModal(`${SITE_URL}${LinkGenerator.portfolio(slide._id)}`);
  const onToggleLike = () => toggleLike(slide._id);

  return (
    <View
      ref={ref}
      visible={inView}
      t={t}
      onStarClick={onToggleLike}
      onClick={onSlideClick}
      isAuth={isAuth}
      isOwner={isOwner}
      onShare={onShare}
      removing={removeMut.isLoading}
      onRemove={removeMut.mutate}
      slide={slide}
      url={url}
      altText={slide.desc || defaultAltText}
      isFavorite={isFavorite}
    />
  );
};
Slide.propTypes = {
  slide: PT.object,
  isOwner: PT.bool,
  isFavorite: PT.bool,
  isAuth: PT.bool,
  index: PT.number,
  defaultAltText: PT.string,

  openShareModal: PT.func.isRequired,
  remove: PT.func,
  toggleLike: PT.func.isRequired,
  t: PT.func.isRequired,
};

export default memo(Slide);
